import { useRouter } from "@/utils";
import { FileTree } from "../../Labeling.types";
import { useAtomValue } from "jotai";
import { labelingParamsAtom } from "../../state";
import { clsx } from "clsx";
import { FileNode } from "./FileNode";

export function DraftItem({
    draft,
    hasLabeledFiles,
    parentId,
}: {
    draft: NonNullable<FileTree["draft"]>;
    hasLabeledFiles: boolean;
    parentId: string;
}) {
    const router = useRouter();
    const companyId = router.params.companyId as string;
    const { selectedFileId, selectedDraftId } =
        useAtomValue(labelingParamsAtom);
    const isSelected =
        selectedFileId === parentId && selectedDraftId === draft.id;

    const lineElement = hasLabeledFiles ? (
        <div
            className={clsx(
                "absolute -bottom-8 left-[7px] top-0 w-px border-l-2 border-dashed border-slate-700",
                "mb-[14px] mt-6",
            )}
        />
    ) : null;

    return (
        <li className={clsx("relative flex flex-col gap-1")}>
            <FileNode
                icon="ring"
                label={
                    draft.status === "uncommitted"
                        ? "Uncommitted Draft"
                        : "Committed Draft"
                }
                id={draft.id}
                date={draft.date}
                to={`/beta/companies/${companyId}/labeling/files/${parentId}/drafts/${draft.id}`}
                lineElement={lineElement}
                isSelected={isSelected}
            />
        </li>
    );
}
